import { render } from "./TaskItem.vue?vue&type=template&id=fbfbad86&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"

import "./TaskItem.vue?vue&type=style&index=0&id=fbfbad86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfbad86"]])

export default __exports__